import * as React from "react";
import styled from "styled-components";

import ToolbarDivider from "./ToolbarDivider";
import ToolbarButton from "./ToolbarButton";

import { ToolbarItemsPropTypes } from "../../vars";

export class UnstyledToolbar extends React.Component<any, any> {
  static propTypes = {
    items: ToolbarItemsPropTypes.toolbarItems
  };

  public state = {
    isClient: false
  };

  componentDidMount() {
    this.setState({ isClient: true });
  }

  renderToolbarButtons = items =>
    items.map(item => (
      <ToolbarButton
        href={this.state.isClient ? item.href : "javascript:void(0)"}
        icon={item.icon}
        key={item.href}
        data-id={item.id}
        isActive={item.isActive}
      >
        {item.text}
      </ToolbarButton>
    ));

  render() {
    const { items, className } = this.props;

    const toolbarButtons = this.renderToolbarButtons(items);

    return (
      <div className={className}>
        <ToolbarDivider />
        {toolbarButtons}
      </div>
    );
  }
}

export default styled(UnstyledToolbar)`
  text-align: center;
  border-bottom: 1px solid ${p => p.theme.colors.grey200};

  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
